export default __webpack_public_path__ + "static/media/icon-check.cb9acdb5.svg";